import React from 'react';
import './WordsToType.css';
import WordMetadataPopup from './Word';
import { Fade } from '@material-ui/core';
const WordsToType = props => (React.createElement("div", { className: props.mode === 'longText' ?
        'WordsToType enlarged-height'
        :
            'WordsToType normal-height', style: { fontSize: (props.fontSize + 'em') } },
    React.createElement(Fade, { in: !(props.words.length === 0) },
        React.createElement("span", null, props.words.map((word, index) => (React.createElement("span", { key: index, id: index === 0 ? 'firstWord' : null },
            React.createElement(WordMetadataPopup, { key: index + word, text: word, typedText: index === props.currentWord ? props.typedText : '', typed: index < props.currentWord, typo: props.typoIndices.includes(index), containsTypo: props.typo, current: index === props.currentWord }),
            React.createElement(Space, null))))))));
const Space = () => (React.createElement("span", null, ' '));
export default WordsToType;
//# sourceMappingURL=WordsToType.js.map